module.exports = __webpack_public_path__ + "img/rightSideBarFavourites.addd4162.png";